import { useEffect } from "react";

const SITE_URL = "https://barverse.com";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Lightweight SEO head manager: title, meta description, canonical, Open Graph,
// Twitter card and JSON-LD structured data — no external dependency.
export default function Seo({ title, description, path = "/", ogImage, jsonLd, keywords }) {
  const fullTitle = title ? `${title} | Barverse` : "Barverse — Cocktails. Tacoverse. Sports. Good Times.";
  const json = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", `${SITE_URL}${path}`);
    setMeta("property", "og:type", "website");
    if (ogImage) setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE_URL}${path}`);

    document.querySelectorAll("script[data-seo-jsonld]").forEach((n) => n.remove());
    if (json) {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "1");
      script.textContent = json;
      document.head.appendChild(script);
    }
  }, [fullTitle, description, path, ogImage, json]);

  return null;
}
